export default "__VITE_ASSET__RdOwkPhX__"